import { render, staticRenderFns } from "./SocialMediasBlock.vue?vue&type=template&id=355eeb2b&scoped=true&"
import script from "./SocialMediasBlock.vue?vue&type=script&lang=js&"
export * from "./SocialMediasBlock.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediasBlock.vue?vue&type=style&index=0&id=355eeb2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355eeb2b",
  null
  
)

export default component.exports